import React from "react"
import { Col, Modal, ModalBody, Row } from "reactstrap"
import { useTranslation } from "react-i18next"

const AlertModal = ({show, onCloseClick, title, msg}) => {
  const { t } = useTranslation()

  return (
    <Modal isOpen={show} toggle={onCloseClick} centered={true}>
      <ModalBody className="py-3 px-5">
        <Row>
          <Col lg={12}>
            <div className="text-center">
              <i className="bx bx-error" style={{ fontSize: "9em" }} />
              <h2 className="my-2">{title}</h2>
              <h6>{msg}</h6>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="text-center mt-3">
              <button
                type="button"
                className="btn btn-primary btn-lg ms-2"
                onClick={onCloseClick}
              >
                {t("btns.Cancel")}
              </button>
            </div>
          </Col>
        </Row>
      </ModalBody>
    </Modal>
  )
}

export default AlertModal
